'use strict';

/**
 * Created by lzy 19-11-03
 * 头条号废稿箱
 */
angular.module('editWeiboDraftBoxModule', ['editWeiboDraftBoxRouterModule']).controller('EditWeiboDraftBoxCtrl', [
    '$scope',
    '$state',
    'modalDialog',
    'trsHttpService',
    'editcenterRightsService',
    'weiboApiParams',
    'weiboApiService',
    'weiboConst',
    'messagePublishService',
    'editingMediatype',
    '$q',
    'editingCenterService',
    function(
        $scope,
        $state,
        modalDialog,
        trsHttpService,
        editcenterRightsService,
        weiboApiParams,
        weiboApiService,
        weiboConst,
        messagePublishService,
        editingMediatype,
        $q,
        editingCenterService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                channelId: $state.params.wbchannelid,
                mediaType: editingMediatype.weibo,
                'status_model': -1,
                isEsSearch: false, // 判断是否是经过ES检索之后
                copyCurrPage: 1,
                hasRight: true,
            };
            $scope.data = {
                items: [],
                keyWords: '',
                wbchannelid: $state.params.wbchannelid,
                docTypeJsons: weiboConst.docTypeJsons,
                docTypeObj: weiboConst.docTypeJsons[0],
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.params = {
                CONTENT: '',
                docType: '',
            };
            $scope.esparams = {}; // es检索参数
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
            initBtnRights();
            refreshList();
        }

        /**
         * [requestData description]数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var deferred = $q.defer();
            let listParams = angular.extend({}, weiboApiParams.listParams, $scope.params, {
                AccountId: $state.params.wbchannelid,
                PageSize: $scope.page.PAGESIZE,
                PageIndex: $scope.page.CURRPAGE,
                FlowStatus: -1,
                CONTENT: '',
                StartTime: $scope.data.fromdate,
                EndTime: timeFormat($scope.data.untildate),
            });
            var params = $scope.status.isEsSearch ? $scope.esparams : listParams;
            if ($scope.status.isEsSearch) {
                params.httpMethod = 'get';
            }
            $scope.loadingPromise = weiboApiService.getList(params).then(function(data){
                if (!$scope.status.isEsSearch) {
                    $scope.data.keyWords = '';
                }
                $scope.data.items = data.DATA;
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.data.selectedArray = [];
                !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = '0');
                deferred.resolve(data);
            },
            function (data) {
                $scope.status.hasRight = false;
            });
            return deferred.promise;
        }

        /**
         * [initBtnRights 初始化微博废稿箱权限]
         *
         * @return  {[type]}
         *   [return description]
         */
        function initBtnRights() {
            editcenterRightsService.initWeiboListBtn('microblog.recycle', $state.params.wbchannelid).then(function(rights) {
                $scope.status.btnRights = rights;
            });
        }
        // 全选
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description]单选
         * @param  {[obj]} item [description]稿件信息
         * @return {[type]}     [description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [isChecked description] 选中状态
         * @param  {[type]}  item [description]
         * @return {Boolean}      [description]
         */
        $scope.isChecked = function(item) {
            if (!item) {
                return;
            }
            var ischecked = false;
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if ($scope.data.selectedArray[i].CHNLDOCID == item.CHNLDOCID) {
                    ischecked = true;
                    break;
                }
            }
            return ischecked;
        };

        /**
         * [fullTextSearch description]搜索
         * @param  {[type]} ev [description]
         * @return {[type]}    [description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = 1;
                $scope.status.isEsSearch = true;
                requestData();
            }
        };

        /**
         * [restore 微博稿件还原]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.restore = function(item) {
            modalDialog.confirmModal('', '确定还原？', function() {
                let params = angular.extend({}, weiboApiParams.restoreParams, {
                    AccountId: $state.params.wbchannelid,
                    MicroContentId: item.SCMMICROCONTENTID,
                    option: '',
                });
                $scope.loadingPromise = weiboApiService.restore(params).then(function(data){
                    requestData();
                    modalDialog.alertType('稿件还原成功', '', 'success', false);
                });
            });
        };

        /**
         * [delete 微博稿件删除]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.delete = function(item) {
            modalDialog.confirmModal('', '确定删除？', function() {
                let params = angular.extend({}, weiboApiParams.deleteParams, {
                    AccountId: $state.params.wbchannelid,
                    MicroContentIds: item.SCMMICROCONTENTID
                });
                $scope.loadingPromise = weiboApiService.delete(params).then(function(data){
                    requestData();
                    modalDialog.alertType('稿件删除成功', '', 'success', false);
                });
            });
        };

        /**
         * [clearTrash description]清空废稿箱
         * @return {[type]} [description]
         */
        $scope.clearTrash = function() {
            modalDialog.confirmModal('', '确定清空？', function() {
                let params = angular.extend({}, weiboApiParams.clearTrashParams, {
                    AccountId: $state.params.wbchannelid,
                });
                $scope.loadingPromise = weiboApiService.clearTrash(params).then(function() {
                    modalDialog.alertType('', '清空废稿箱成功', 'success', true);
                    requestData();
                },
                function(data) {
                    modalDialog.alertType('', '清空废稿箱失败', 'error', 'confirm');
                });
            });
        };

        /*
         * [pageChanged description]翻页
         */
        $scope.pageChanged = function() {
            $scope.loadingPromise = requestData();
        };

        /*
         * [jumpToPage description]跳页
         */
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = angular.copy($scope.status.copyCurrPage);
            $scope.loadingPromise = requestData();
        };

        /**
         * [queryByDropdown description] 下拉框回调函数
         *
         * @param   {[type]}  type   [type description]
         * @param   {[type]}  value  [value description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.queryByDropdown = function(type, value) {
            $scope.page.CURRPAGE = 1;
            $scope.params[type] = value;
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };

        /*
         * [timeSelect description] 时间筛选
         * @return {[type]} [description]
         */
        $scope.timeSelect = function () {
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };

        /**
         * [timeFormat description] 日期day+1处理
         * @param  {[String]} timeStr [description]日期字符串
         * @return {[type]}         [description]
         */
        function timeFormat(timeStr) {
            if (angular.isDefined(timeStr) && timeStr != '') {
                var date = timeStr.replace(/-/g, '/');
                var timestamp = new Date(date).getTime();
                timestamp = timestamp + 24 * 60 * 60 * 1000;
                var d = new Date(timestamp);
                return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            } else {
                return '';
            }
        }

        /**
         * [refreshList description]刷新列表
         * @return  {[undefined]}  [return description]
         */
        function refreshList() {
            messagePublishService.subscribe(
                'refresh',
                function (event, data) {
                    if ((typeof data) === 'object') {
                        $scope.status.isEsSearch = true; // es检索状态
                        $scope.esparams = data;
                    } else {
                        $scope.status.isEsSearch = false;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                },
                $scope
            );
        }

        /**
         * [showVersionTime description] 流程版本时间与操作日志
         * @param   {[object]}  item  [item description] 稿件对象
         * @return  {[type]}          [return description]
         */
        $scope.showVersionTime = function (item) {
            editingCenterService.getVersionTime(item, false);
        };
    },
]);
